// Module
var code = "<div class=\"abx-static-floor-plan\"> <md-progress-circular ng-show=\"vm.loading\" md-theme=\"default\" md-mode=\"indeterminate\" md-diameter=\"32\" class=\"md-accent ng-hide\"></md-progress-circular> <div class=\"abx-static-floor-plan__img-container\"> <img class=\"abx-static-floor-plan__img\"/> </div> </div> ";
// Exports
module.exports = code;